/**
 * Knox option matrix v2 — query-param preservation and native-picker suppression only.
 *
 * Every pill is now server-rendered as a real link to a real product (snippets/knox-option-matrix
 * .liquid builds it from a list of product references, not a declared-value list matched against
 * a coordinate). There is no model to build and no combination to resolve — this file adds only
 * the two things a template can't do itself:
 *   1. carry the current query string onto each pill (Liquid has no access to location.search),
 *      dropping variant/selling_plan since those belong to the product the visitor is ON, not
 *      the one a pill points to.
 *   2. hide the theme's own native variant picker once a real family selector is already on the
 *      page for this product, so the shopper isn't shown the same choice twice.
 */
(function () {
  'use strict';

  function withParams(href, search) {
    if (!href || !search || search === '?') return href;
    const [path, ownQuery] = href.split('?');
    const incoming = new URLSearchParams(search);
    const merged = new URLSearchParams(ownQuery || '');
    incoming.forEach((v, k) => {
      if (k === 'variant' || k === 'selling_plan') return;
      if (!merged.has(k)) merged.append(k, v);
    });
    const q = merged.toString();
    return q ? path + '?' + q : path;
  }

  /** Same rule as before: exactly one native picker on the page, hide it; more than one, only
   * hide an exact match by product-url; ambiguous, leave every one of them alone. */
  function suppressNativePicker(doc, currentPath) {
    const candidates = Array.from(doc.querySelectorAll('[data-variant-selection]'));
    if (candidates.length === 0) return;
    let target = candidates.length === 1 ? candidates[0] : null;
    if (!target && currentPath) {
      const matches = candidates.filter((el) => {
        const url = el.getAttribute('product-url') || '';
        return url.indexOf(currentPath) === 0;
      });
      if (matches.length === 1) target = matches[0];
    }
    if (target) {
      target.setAttribute('data-knox-native-suppressed', 'true');
      target.style.display = 'none';
    }
  }

  function init(scope) {
    const root = scope || (typeof document !== 'undefined' ? document : null);
    if (!root) return;
    const hosts = root.querySelectorAll('knox-option-matrix');
    if (hosts.length === 0) return;
    const win = root.ownerDocument ? root.ownerDocument.defaultView : window;
    const search = (win && win.location && win.location.search) || '';
    const path = (win && win.location && win.location.pathname) || '';
    hosts.forEach((host) => {
      host.querySelectorAll('a[data-knox-nav]').forEach((a) => {
        a.setAttribute('href', withParams(a.getAttribute('href'), search));
      });
      suppressNativePicker(host.ownerDocument, path);
    });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    /* Theme editor re-renders sections without a page load. */
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { withParams, suppressNativePicker, init };
  }
})();
